import { useEffect } from 'react'

import { Toast } from '@heroui/react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'

import { ProtectedRoute } from '@/components/ProtectedRoute'
import AppLayout from '@/layouts/AppLayout'
import AnalyticsPage from '@/pages/Analytics'
import AuthPage from '@/pages/Auth/AuthPage'
import ResetPasswordPage from '@/pages/Auth/ResetPasswordPage'
import VerifyEmailPage from '@/pages/Auth/VerifyEmailPage'
import Dashboard from '@/pages/Dashboard'
import DriversList from '@/pages/Drivers'
import { DriverForm } from '@/pages/Drivers/DriverDialog'
import NotFound from '@/pages/NotFound'
import ReportForm from '@/pages/Reports/ReportForm'
import ReportsList from '@/pages/Reports/ReportsList'
import ReportView from '@/pages/Reports/ReportView'
import SettlementsList from '@/pages/Settlements'
import SettlementDetail from '@/pages/Settlements/SettlementDetail'
import TimesheetForm from '@/pages/Timesheet/TimesheetForm'
import TimesheetList from '@/pages/Timesheet/TimesheetList'
import TimesheetView from '@/pages/Timesheet/TimesheetView'
import UploadsPage from '@/pages/Uploads'
import UsersList from '@/pages/Users'
import VehicleAnalyticsPage from '@/pages/VehicleAnalytics'
import VehiclesList from '@/pages/Vehicles'
import VehicleForm from '@/pages/Vehicles/components/VehicleForm.tsx'
import WarehouseList from '@/pages/Warehouse'
import { useAuthStore } from '@/store/auth.store'

const router = createBrowserRouter([
  {
    path: '/login',
    element: <AuthPage />,
  },
  {
    path: '/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/reports" replace /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'reports', element: <ReportsList /> },
      { path: 'reports/new', element: <ReportForm /> },
      { path: 'reports/:id', element: <ReportView /> },
      { path: 'reports/:id/edit', element: <ReportForm /> },
      { path: 'drivers', element: <DriversList /> },
      { path: 'drivers/new', element: <DriverForm /> },
      { path: 'drivers/:id/edit', element: <DriverForm /> },
      { path: 'settlements', element: <SettlementsList /> },
      { path: 'settlements/:id', element: <SettlementDetail /> },
      { path: 'vehicles', element: <VehiclesList /> },
      { path: 'vehicles/new', element: <VehicleForm /> },
      { path: 'vehicles/:id/edit', element: <VehicleForm /> },
      { path: 'analytics', element: <AnalyticsPage /> },
      { path: 'vehicle-analytics', element: <VehicleAnalyticsPage /> },
      { path: 'timesheet', element: <TimesheetList /> },
      { path: 'timesheet/new', element: <TimesheetForm /> },
      { path: 'timesheet/:id', element: <TimesheetView /> },
      { path: 'timesheet/:id/edit', element: <TimesheetForm /> },
      { path: 'users', element: <UsersList /> },
      { path: 'warehouse', element: <WarehouseList /> },
      { path: 'uploads', element: <UploadsPage /> },
    ],

  },
  {
    path: '*',
    element: <NotFound />,
  },
], {
  basename: import.meta.env.VITE_PUBLIC_URL || '/',
})

export default function App() {
  const checkAuth = useAuthStore(s => s.checkAuth)

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  return (
    <>
      <Toast.Provider placement={'top'} />
      <RouterProvider router={router} />
    </>
  )
}
